<template>
    <div :class="['visual-vr', modify]">
        <VrIcon>
            <div class="visual-vr__banner">
                <div class="visual-vr__image-wrap">
                    <img class="visual-vr__image j-object-fit" src="/images/visual/vr-image.jpg">
                </div>
                <div class="visual-vr__info">
                    <p class="visual-vr__title">Виртуальные туры по квартирам</p>
                    <p class="visual-vr__text">
                        На странице квартиры отсканируйте QR код с помощью приложения
                        Planoplan RE и наслаждайтесь прогулкой в виртуальной реальности
                    </p>
                </div>
            </div>
        </VrIcon>
    </div>
</template>

<style lang="scss">
    @import "./Vr.scss";
    @import "components/vr-icon/vr-icon.scss";
</style>

<script>
import VrIcon from 'components/vr-icon/VrIcon.vue';

export default {
    props: ['modify'],

    data() {
        return {isOpen: false};
    },

    components: {VrIcon}
};
</script>
